import { Component } from 'react';
import { FieldProps } from 'formik';

import { BraxField } from '../BraxField';
import { BraxRadioValue, BraxUncontrolledRadioField, BraxUncontrolledRadioFieldProps } from '../../BraxUncontrolledForm';

export type BraxRadioFieldProps<V extends BraxRadioValue> = BraxUncontrolledRadioFieldProps<V> & {
    readOnly?: boolean
};

export class BraxRadioField<V extends BraxRadioValue> extends Component<BraxRadioFieldProps<V>> {

    static defaultProps = {
        disabled: false,
        readOnly: false
    };

    change(value: V, formik: FieldProps) {
        formik.form.handleChange({
            target: {
                type: 'text',
                name: this.props.name,
                value: value
            }
        });

        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        const { name, disabled, readOnly, onChange, ...props } = this.props;

        return (
            <BraxField name={name} disabled={disabled} readOnly={readOnly}>
                { ({ formik, ...fieldProps }) => (
                    <BraxUncontrolledRadioField<V>
                        {...fieldProps}
                        {...props}
                        onChange={value => this.change(value, formik)}
                    />
                ) }
            </BraxField>
        );
    }

}
